module.exports = new __parcel__URL__("user-gray-light.b6caaf13.svg").toString();